import { CommonModule } from '@angular/common';
import { Component, computed, input, output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { I18NextPipe } from 'angular-i18next';
import { SelectComponent } from 'mbs-ui-kit';
import { AzureAccessTierType, StorageClass } from 'mbs-ui-shared@models';

@Component({
  standalone: true,
  selector: 'mbs-advanced-options-storage-class-azure-tier',
  templateUrl: './advanced-options-storage-class-azure-tier.component.html',
  imports: [CommonModule, ReactiveFormsModule, SelectComponent, I18NextPipe]
})
export class AdvancedOptionsStorageClassAzureTierComponent {
  parentForm = input.required<FormGroup>();
  advancedOptionsFlags = input.required<Record<string, unknown>>();
  showStorageClass = input<boolean>();
  showAzureTires = input<boolean>();
  storageClasses = input.required<Array<{ value: number; label: string | number }>>();
  accessTires = input.required<Array<{ value: number; label: string | number }>>();
  isVM = input<boolean>(false);
  layout = input<'standard' | 'compact'>('standard');

  storageClassChange = output<StorageClass>();
  azureTierChange = output<AzureAccessTierType>();

  isCompactLayout = computed(() => {
    return this.layout() === 'compact';
  });
}
